var o = Object.defineProperty;
var m = (t, e, r) => e in t ? o(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var s = (t, e, r) => (m(t, typeof e != "symbol" ? e + "" : e, r), r);
import { constructFrom as p } from "../../../constructFrom.js";
import { Parser as a } from "../Parser.js";
import { parseAnyDigitsSigned as n } from "../utils.js";
class g extends a {
  constructor() {
    super(...arguments);
    s(this, "priority", 20);
    s(this, "incompatibleTokens", "*");
  }
  parse(r) {
    return n(r);
  }
  set(r, c, i) {
    return [p(r, i), { timestampIsSet: !0 }];
  }
}
export {
  g as TimestampMillisecondsParser
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/parse/_lib/parsers/TimestampMillisecondsParser.js
// module id = 1436
// module chunks = 67